import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getGeckos = () => axios.get(`${API}/geckos`).then((r) => r.data);
export const getProducts = () => axios.get(`${API}/products`).then((r) => r.data);
export const getTerrariums = () => axios.get(`${API}/terrariums`).then((r) => r.data);
export const postEnquiry = (payload) => axios.post(`${API}/enquiries`, payload).then((r) => r.data);
export const checkShipping = (postal) =>
  axios.get(`${API}/shipping/check`, { params: { postal } }).then((r) => r.data);
export const postCheckout = (payload) =>
  axios.post(`${API}/checkout`, payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const formatDkk = (n) => `${Number(n).toLocaleString("da-DK")} kr`;

const adminHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const getAdminOrders = (token) =>
  axios.get(`${API}/admin/orders`, adminHeaders(token)).then((r) => r.data);
export const getAdminEnquiries = (token) =>
  axios.get(`${API}/admin/enquiries`, adminHeaders(token)).then((r) => r.data);
export const getAdminItems = (token) =>
  axios.get(`${API}/admin/items`, adminHeaders(token)).then((r) => r.data);
export const getAdminAnalytics = (token) =>
  axios.get(`${API}/admin/analytics`, adminHeaders(token)).then((r) => r.data);
export const trackPage = (path) =>
  axios
    .post(`${API}/track`, {
      path,
      ref: document.referrer ? new URL(document.referrer).hostname : "",
    })
    .catch(() => {});
export const updateAdminItem = (collection, slug, payload) =>
  axios
    .put(
      `${API}/admin/items/${collection}/${slug}`,
      payload,
      adminHeaders(localStorage.getItem("gf_admin") || "")
    )
    .then((r) => r.data);
export const createAdminItem = (collection, payload) =>
  axios
    .post(
      `${API}/admin/items/${collection}`,
      payload,
      adminHeaders(localStorage.getItem("gf_admin") || "")
    )
    .then((r) => r.data);
export const deleteAdminItem = (collection, slug) =>
  axios
    .delete(
      `${API}/admin/items/${collection}/${slug}`,
      adminHeaders(localStorage.getItem("gf_admin") || "")
    )
    .then((r) => r.data);
export const uploadAdminImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/admin/upload`, form, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
};
export const createAdminEvent = (payload) =>
  axios
    .post(`${API}/admin/events`, payload, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const updateAdminEvent = (id, payload) =>
  axios
    .put(`${API}/admin/events/${id}`, payload, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const deleteAdminEvent = (id) =>
  axios
    .delete(`${API}/admin/events/${id}`, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const updateAdminSettings = (payload) =>
  axios
    .put(`${API}/admin/settings`, payload, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const getAdminReviews = () =>
  axios
    .get(`${API}/admin/reviews`, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const updateAdminReview = (id, approved) =>
  axios
    .put(`${API}/admin/reviews/${id}`, { approved }, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const deleteAdminReview = (id) =>
  axios
    .delete(`${API}/admin/reviews/${id}`, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const syncShipmondo = () =>
  axios
    .post(`${API}/admin/shipmondo/sync`, {}, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);

export const customerRegister = (payload) =>
  axios.post(`${API}/auth/register`, payload).then((r) => r.data);
export const googleSession = (sessionId) =>
  axios.post(`${API}/auth/google/session`, { session_id: sessionId }).then((r) => r.data);
export const getMe = (token) =>
  axios.get(`${API}/auth/me`, adminHeaders(token)).then((r) => r.data);
export const updateMe = (payload) =>
  axios
    .put(`${API}/auth/me`, payload, adminHeaders(localStorage.getItem("gf_customer") || ""))
    .then((r) => r.data);
export const getMyOrders = (token) =>
  axios.get(`${API}/auth/my-orders`, adminHeaders(token)).then((r) => r.data);

export const getVare = (slug) => axios.get(`${API}/vare/${slug}`).then((r) => r.data);
export const getEvents = () => axios.get(`${API}/events`).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const getInstagramMedia = (limit = 6) =>
  axios.get(`${API}/instagram/media`, { params: { limit } }).then((r) => r.data.data || []);
export const getLineage = () => axios.get(`${API}/lineage`).then((r) => r.data);
export const createAdminAnimal = (payload) =>
  axios
    .post(`${API}/admin/lineage`, payload, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const updateAdminAnimal = (id, payload) =>
  axios
    .put(`${API}/admin/lineage/${id}`, payload, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const deleteAdminAnimal = (id) =>
  axios
    .delete(`${API}/admin/lineage/${id}`, adminHeaders(localStorage.getItem("gf_admin") || ""))
    .then((r) => r.data);
export const getPickupPoints = (postal) =>
  axios.get(`${API}/shipping/pickup-points`, { params: { postal } }).then((r) => r.data);
export const getReviews = (slug) =>
  axios.get(`${API}/vare/${slug}/reviews`).then((r) => r.data);
export const postReview = (slug, payload) =>
  axios.post(`${API}/vare/${slug}/reviews`, payload).then((r) => r.data);
export const forgotPassword = (payload) =>
  axios.post(`${API}/auth/forgot-password`, payload).then((r) => r.data);
export const resetPassword = (payload) =>
  axios.post(`${API}/auth/reset-password`, payload).then((r) => r.data);

export const scrollToSection = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -64, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const HERO_BG =
  "https://images.unsplash.com/photo-1533563906091-fdfdffc3e3c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZm9yZXN0JTIwZmVybiUyMHRleHR1cmV8ZW58MHx8fHwxNzg2MzE3MTAxfDA&ixlib=rb-4.1.0&q=85&w=2000&auto=format&fit=crop";
